import { makeStyles, Theme } from '@material-ui/core'
import { FullScreenStepperProgressProps } from './FullScreenStepperProgressProps'

const getBorderRadius = (theme: Theme, props: FullScreenStepperProgressProps) => {
  const { stepCursor, stepCount } = props
  const isFinalStep = stepCursor / stepCount === 1
  if (isFinalStep) {
    return 0
  } else {
    return theme.spacing(0.5)
  }
}

export const useFullScreenStepperProgressStyles = makeStyles<Theme, FullScreenStepperProgressProps>((theme) => ({
  progress: {
    width: (props) => `${(props.stepCursor / props.stepCount) * 100}%`,
    transition: 'all 500ms',
    height: theme.spacing(1),
    background: `linear-gradient(45deg, ${theme.palette.primary.gradientStart}, ${theme.palette.primary.gradientEnd})`,
    borderEndEndRadius: (props) => getBorderRadius(theme, props),
    borderStartEndRadius: (props) => getBorderRadius(theme, props),
  },
  track: {
    position: 'absolute',
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    height: theme.spacing(0.5),
    background: theme.palette.grey[100],
    zIndex: 2,
  },
}))
